import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle', 'icon'];

  connect() {
  }

  toggle() {
    const toggle = this.toggleTarget;
    const isExpanding = toggle.classList.contains('h-0');

    if (isExpanding) {
      // Set max-height to actual content height instead of arbitrary value
      toggle.style.maxHeight = `${toggle.scrollHeight}px`;
      toggle.classList.remove('h-0', 'opacity-0');
      toggle.classList.add('opacity-100');
      this.iconTarget.style.transform = 'rotate(90deg)';
    } else {
      toggle.style.maxHeight = '0px';
      toggle.classList.add('h-0', 'opacity-0');
      toggle.classList.remove('opacity-100');
      this.iconTarget.style.transform = 'rotate(0deg)';
    }
  }
}
